import { Component, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingBarComponent } from '@base/components/loading-bar';
import { ThemeSwitcherComponent } from 'app/layout/common/theme-switcher/theme-switcher.component';

@Component({
  selector: 'empty-layout',
  templateUrl: './empty.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [LoadingBarComponent, RouterOutlet, ThemeSwitcherComponent],
})
export class EmptyLayoutComponent {
  /**
   * Constructor
   */
  constructor() {}
}
